import React from 'react';

import { t } from 'ttag';

import ErrorDetails from '../errorDetails/errorDetails';

const AuthError = () => (
    <ErrorDetails
        linkTo="/auth/login"
        linkLabel={t`Повернутися до сторінки Входу`}
        text={t`Можливо ви перейшли за поганим посиланням, або сторінки вже не існує.`}
        title={t`Сторінку не знайдено`}
        useNativeLink={false}
    />
);

export default AuthError;
